<template>
  <div class="edit-org-name-box">
    <header-back
      :title="delTit"
      @back="resetHandler"
    />
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item>
        <div class="cube-form-tip-box">
          <h3>{{ $t('message["1584"]') }}  {{ this.$route.query.projectname }}</h3>
          <!-- <p>{{ $t('message["979"]') }}。</p> -->
          <p>项目删除后，项目内的所有数据将一并删除且不可恢复。</p>
        </div>
      </cube-form-item>
      <cube-form-item class="cube-form-item-tip">
        请按照下方输入框内的提示文案逐字输入
      </cube-form-item>
      <cube-form-item :field="fields[0]" />
      <div class="form-btn-box">
        <cube-button
          :light="true"
          type="reset"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import HeaderBack from '@/components/mobile/HeaderBack'
import { mapActions } from 'vuex'
export default {
  components: {
    HeaderBack
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        confirm: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'confirm',
          label: '请输入', // this.$t('message["1432"]'),
          props: {
            placeholder: this.$t('message["1925"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    delTit () {
      return this.$t('message["978"]')
    },
    type () {
      const { type = 'inquery' } = this.$route.query
      return type
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxDelPro', 'fetchProjectList']),
    async submitHandler (e) {
      let obj = {}
      const { type } = this
      const pType = type === 'inquery' ? 1 : 2
      const chain = await this.ajaxDelPro({ cid: this.$route.query.cid })
      obj = Object.assign(this.model, { cid: this.$route.query.cid, projectid: this.$route.query.projectid, pType })
      chain.params(obj)
        .onSuccess(async raw => {
          this.$router.push({
            name: 'ProjectIndexPc',
            query: {
              page: 2,
              cid: this.$route.query.cid,
              type
            } })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 2,
          cid: this.$route.query.cid,
          type: this.type
        } })
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit-org-name-box::v-deep {
    .cube-form-item {
      min-height: 56px;
      line-height: 56px;
      .cube-form-label {
        color: #888;
      }
    }
    .cube-form-item-box .find-pwd-box {
      top: 16px;
    }
  }
  .cube-form-tip-box{
    h3 {
      color: #f57676;
      font-size: 14px;
    }
    p {
      color: #999;
      white-space: nowrap;
    }
  }
  .cube-form-item-tip {
    background:#f3f3f3 ;
    height: 36px !important;
    line-height: 36px !important;
    color: #888 !important;
  }
</style>
